import PromptSection from "../../Pages/AiPrompts/PromptSection";
import ApplicationUsersSection from "../../Pages/ApplicationUsers/ApplicationUsersSection";
import BuilderUsersSection from "../../Pages/BuilderUsers/BuilderUsersSection";
import ChartEditor from "../../Pages/ChartEditor/ChartEditor";
import Charts from "../../Pages/ChartEditor/Charts";
import ClusterManagerSection from "../../Pages/ClusterManager/ClusterManagerSection";
import MetricsSection from "../../Pages/Metrics/metricsSection";
import PositionedTemplates from "../../Pages/PositionedTemplates/PositionedTemplates";
import SmTemplates from "../../Pages/SmTemplates/SmTemplates";
import ThemeEditor from "../../Pages/Themes/ThemeEditor/ThemeEditor";
import ThemeSection from "../../Pages/Themes/ThemeSection";
import { organizationRoutes } from "./organizationRoutes";
import { USER_ROLES } from "./userRoles";
import RoleGuard from "../authorization/RoleGuard";
import { ROOT_ROUTE_SEGMENTS } from "../routesConstant";
import ProxyRoutes from "../../Pages/ProxyRoutes/ProxyRoutes";
import ReleasesViewer from "../../Pages/Releases/ReleasesViewer";
import UserManagement from "../../Pages/UserManagement/UserManagement";
import UserLogs from "../../Pages/Monitor/UserLogs";
import KeyVaultSection from "../../Pages/KeyVault/KeyVaultSection";

export const authRoute = [
  {
    element: <RoleGuard allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]} />,
    children: [
      {
        path: ROOT_ROUTE_SEGMENTS.BUILDER_USER,
        element: <BuilderUsersSection />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.USER_SERVICE,
        element: <ApplicationUsersSection />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.SM_TEMPLATES,
        element: <SmTemplates />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.SCREEN_TEMPLATES,
        element: <PositionedTemplates />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.PROXY_ROUTES,
        element: <ProxyRoutes />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.RELEASES,
        element: <ReleasesViewer />
      },
      {
        path: ROOT_ROUTE_SEGMENTS.CLUSTER_MANAGER,
        element: <ClusterManagerSection />
      }
    ]
  },
  {
    path: ROOT_ROUTE_SEGMENTS.THEME,
    element: <ThemeSection />
  },
  {
    path: `${ROOT_ROUTE_SEGMENTS.THEME}/${ROOT_ROUTE_SEGMENTS.THEME_ID_PARAM}`,
    element: <ThemeEditor />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.CHARTS,
    element: <Charts />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.CHART_EDITOR,
    element: <ChartEditor />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.PROMPT,
    element: <PromptSection />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.METRICS,
    element: <MetricsSection />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.USER_MANAGEMENT,
    element: <UserManagement />
  },
  {
    path: ROOT_ROUTE_SEGMENTS.USER_LOGS,
    element: <UserLogs />
  },
  {
    // Platform-level Azure Key Vault secrets editor. Not app-scoped (no
    // Zino-App-Id) and not in any nav menu. Access is restricted STRICTLY to the
    // devops-admin role (super-admin is intentionally NOT included), matching the
    // backend's devops-only guard on /keyvault/*.
    element: <RoleGuard allowedRoles={[USER_ROLES.DEVOPS_ADMIN]} />,
    children: [
      {
        path: ROOT_ROUTE_SEGMENTS.KEY_VAULT,
        element: <KeyVaultSection />
      }
    ]
  },
  {
    path: ROOT_ROUTE_SEGMENTS.ORGANIZATION,
    children: organizationRoutes
  }
];
